import {memo} from 'react'
import type {Iri} from '../../@types/Api'
import {useSpotGet} from '../../hooks/entity/useSpot'
import {TextSkeleton} from '../Skeleton/TextSkeleton'

interface Props {
  spotIri: Iri
}

export const SpotLabel = memo(({spotIri}: Props) => {
  const {spot, error} = useSpotGet(spotIri)

  if (!spot) {
    return <TextSkeleton width={100} error={error}/>
  }

  return spot.name
})
